import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ContentCategoryForm from '../../../components/forms/ContentCategoryForm';
import { useContentCategoryApi } from '../../../hooks/useContentCategoryApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ContentCategoryDTO } from '../../../services/apiClient';

const ContentCategoryEdit: React.FC = () => {
  const { getById, edit } = useContentCategoryApi();
  const [entityData, setEntityData] = useState<ContentCategoryDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Content Categories', href: '/admin/contentcategories' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ContentCategory data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/contentcategories');
    } catch (error) {
      console.error('Error updating ContentCategory:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/contentcategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ContentCategory.Edit'
    >
        {entityData ? (
          <ContentCategoryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/contentcategories')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ContentCategoryEdit;